import { GatewayAuthentication } from "@conformite/gateway";
import { Button, Card, Dropdown, Link } from "@endya-conformite/ui-kit";
import ChevronDown from "@endya-conformite/ui-kit/src/assets/icons/chevron-down.svg?react";
import Person from "@endya-conformite/ui-kit/src/assets/icons/person.svg?react";
import QuestionCircle from "@endya-conformite/ui-kit/src/assets/icons/question-circle.svg?react";
import { useIsAllowed } from "@src/session/useIsAllowed";
import { useSession } from "@src/session/UserSessionContext";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import style from "./UserMenu.module.scss";

export function UserMenu() {
  const session = useSession();
  const navigate = useNavigate();
  const { hasAllowedCognitoRole } = useIsAllowed();

  const handleLogout = useCallback(async () => {
    try {
      await session.logout();
    } catch (e) {
      console.error("Error while logging out", e);
    }
    navigate("/login");
  }, [session, navigate]);

  return (
    <Card className={style.menuWrapper}>
      <Button variant="outline" className={style.questionButton}>
        <Link
          to="/services/des-tutoriels-guides-sont-disponibles-pour-vous-accompagner"
          target="_blank"
          className={style.questionButtonIcon}
        >
          <QuestionCircle />
        </Link>
      </Button>

      <Dropdown
        dismissOnClick
        withIcon={false}
        variant="outline-pop"
        placement="bottom-start"
        ariaLabel="Menu utilisateur"
        content={
          <div className={style.actionButtonInnerWrapper}>
            <span className={style.actionPersonIcon}>
              <Person />
            </span>
            <ChevronDown className={style.chevronDownAction} />
          </div>
        }
        className={style.actionButton}
      >
        {({ close }) => (
          <div>
            <Link to="/parametres/informations-personnelles">
              <Button variant="text" onClick={close}>
                Paramètres
              </Button>
            </Link>
            {hasAllowedCognitoRole(GatewayAuthentication.Role.ENDYA) && (
              <Button
                variant="text"
                onClick={() => {
                  localStorage.removeItem("adminContactId");
                  localStorage.removeItem("adminEntreprisePrincipalId");
                  void handleLogout().finally(close);
                }}
                className={style.disconnectButton}
              >
                Quitter la session
              </Button>
            )}
            <Button
              variant="text"
              onClick={() => {
                void handleLogout().finally(close);
              }}
              className={style.disconnectButton}
            >
              Me déconnecter
            </Button>
          </div>
        )}
      </Dropdown>
    </Card>
  );
}
